import { render, staticRenderFns } from "./u-pagination-text-color.vue?vue&type=template&id=789db355&scoped=true&"
import script from "./u-pagination-text-color.vue?vue&type=script&lang=js&"
export * from "./u-pagination-text-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789db355",
  null
  
)

export default component.exports